module.exports = __webpack_public_path__ + "static/9-248bef38c1445080407b3d98b09ff525.png";